import { commonEnvConfig } from '@datachain/ui-sdk/common';

export const environment = {
	...commonEnvConfig,
	enableDebug: false,
	production: true,
	localePath: './src/assets/locales/generated',
};
